/*
SLA presentation.

The ticket list endpoint returns `sla_status` as a bare enum - the display text
and icon live here, on the frontend. Anything outside the documented enum
degrades to a dash rather than throwing.
*/

export const SLA_PRESENTATION = {
  // Key stays `blocked` to match the API enum; shown as "On Hold".
  blocked: {
    icon: "⏸",
    label: "On Hold",
    detail: "",
    tone: "blocked",
  },
  unresolved: {
    icon: "⏱",
    label: "Past SLA",
    detail: "unresolved",
    tone: "breach",
  },
  no_response: {
    icon: "⏱",
    label: "No response",
    detail: "48h+",
    tone: "breach",
  },
  on_track: {
    icon: "✓",
    label: "On track",
    detail: "",
    tone: "ontrack",
  },
  closed: {
    icon: "✓",
    label: "Closed",
    detail: "",
    tone: "closed",
  },
};

export const slaPresentation = function (value) {
  return SLA_PRESENTATION[value] || null;
};

// Drives the red left border on a case row, and matches the "SLA breach" chip.
export const isBreach = function (value) {
  return value === "unresolved" || value === "no_response";
};

/*
The five filter chips. Each carries the query params it contributes, so the
container never has to branch on the chip key.
*/
export const FILTER_CHIPS = [
  { key: "all", label: "All", params: { filter_criteria: "all" } },
  { key: "sla_breach", label: "SLA breach", params: { sla: "breach" } },
  { key: "blocked", label: "On Hold", params: { sla: "blocked" } },
  { key: "open", label: "Open", params: { filter_criteria: "open" } },
  { key: "complete", label: "Complete", params: { filter_criteria: "archived" } },
];

export const DEFAULT_CHIP = "all";

export const chipParams = function (key) {
  const chip = FILTER_CHIPS.filter(function (c) {
    return c.key === key;
  })[0];
  return chip ? chip.params : FILTER_CHIPS[0].params;
};

export default FILTER_CHIPS;
